// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__36Sxl","author":"Table_author__3J-MA","authorImage":"Table_authorImage__2kXqa","unreadRow":"Table_unreadRow__3CkAg"};